import { classNames, convertToCurrencyFormat } from "../../../shared/utility";

interface Item {
  user_id: number;
  name: string;
  total_orders: string;
  sub_dollar_amount: string;
}

interface TopSalesPersonsStatsProps {
  topSalesPersonsStats: Item[];
  loading: Boolean;
}

const TopSellingSalesPersons: React.FC<TopSalesPersonsStatsProps> = ({
  topSalesPersonsStats,
  loading,
}) => {
  return (
    <li className="overflow-hidden h-max rounded-xl border border-gray-200 shadow-md">
      <div className="flex infos-center gap-x-4 border-b border-gray-900/5 bg-gray-50 px-6 py-4">
        <div className="text-xl font-medium leading-6 text-gray-900">
          Top Selling Salespersons
        </div>
      </div>

      <div className="overflow-hidden bg-white">
        <table className="min-w-full">
          <thead>
            <tr className="text-lg">
              <th
                scope="col"
                className="pl-2 py-2 pr-3 text-left font-semibold text-gray-900"
              >
                Name
              </th>
              <th
                scope="col"
                className="px-3 py-2 text-left font-semibold text-gray-900"
              >
                Orders
              </th>
              <th
                scope="col"
                className="px-3 py-2 text-right font-semibold text-gray-900"
              >
                Sales
              </th>
            </tr>
          </thead>
          <tbody>
            {topSalesPersonsStats.length > 0 ? (
              topSalesPersonsStats.map((person, index) => (
                <tr
                  key={person.user_id}
                  className={classNames(
                    index % 2 === 1 ? "bg-gray-100" : null,
                    "text-md"
                  )}
                >
                  <td className="pl-2 py-1.5 pr-3 font-medium text-gray-900">
                    {person.name}
                  </td>
                  <td className="px-3 py-1.5 font-medium text-gray-900">
                    {person.total_orders}
                  </td>
                  <td className="px-3 py-1.5 font-bold text-gray-900 text-right">
                    {convertToCurrencyFormat(person.sub_dollar_amount)}
                  </td>
                </tr>
              ))
            ) : (
              <tr>
                <td colSpan={3} className="text-center"></td>
              </tr>
            )}
          </tbody>
        </table>
      </div>
    </li>
  );
};

export default TopSellingSalesPersons;
